/* Dialog help has no access to variant values or cart submission. */
(() => {
  if (customElements.get('aashop-size-guide')) return;
  class AASizeGuide extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      queueMicrotask(() => this.connect());
    }
    connect() {
      if (!this.isConnected) return;
      this.trigger = this.querySelector('[data-size-guide-trigger]');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || typeof this.dialog?.showModal !== 'function') return;
      const signal = this.abort.signal;
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-controls', this.dialog.id);
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        if (!this.dialog.open) this.dialog.showModal();
      }, {signal});
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')).filter(el => el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        if (this.trigger.isConnected) this.trigger.focus({preventScroll:true});
      }, {signal});
      if (this.dataset.placement === 'main') {
        this.info = this.closest('.product-info');
        this.attach();
        if (this.info) {
          this.observer = new MutationObserver(() => this.attach());
          this.observer.observe(this.info, {childList:true, subtree:true});
        }
      }
    }
    attach() {
      if (!this.isConnected || !this.info || !this.trigger) return;
      const option = Array.from(this.info.querySelectorAll('variant-picker .variant-picker__option')).find(el => /^(størrelse|size|storlek|größe|taille)\s*:?$/i.test(el.querySelector('legend')?.textContent.trim() || ''));
      const header = option?.querySelector('.variant-picker__option-info');
      if (!header || this.trigger.parentElement === header) return;
      header.append(this.trigger);
      this.dataset.attached = '';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      // A native variant render can replace this host but retain its old header.
      if (this.trigger && !this.contains(this.trigger)) this.trigger.remove();
    }
  }
  customElements.define('aashop-size-guide', AASizeGuide);
})();
